import React from "react";
import Page, { PageProps } from "./Page";
import Header from "../components/Header";

export interface Props extends PageProps {}
export interface State {}

export default class EmptyPage extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {}
  componentWillUnmount() {}

  render() {
    const { title, text } = this.state as any;

    return (
      <Page {...this.props}>
        <div>
          <Header title={title} languagePickerVisible={false} />
        </div>
        <div className="empty-page-content-wrapper">
          <div className={"empty-page-content"}>
            <div className={"empty-page-content-title"}>{title && <span>{title}</span>}</div>
            <div>{text && <span>{text}</span>}</div>
          </div>
        </div>
      </Page>
    );
  }
}
